
import { type FC, memo, useCallback, useMemo } from 'react';

import { translations } from './SelectLanguage';

import './ThankYouScreen.css';

interface ThankYouScreenProps {
    onShowResultsClick: ()=> void;
    answersTotal: number;
    correctAnswers: number;
}

export const ThankYouScreen: FC<ThankYouScreenProps> = memo(({
    onShowResultsClick,
    correctAnswers,
    answersTotal,
}) => {
    const handleShowResultsClick = useCallback(() => {
        onShowResultsClick();
    },[onShowResultsClick]);

    const getResultText = useMemo((): string => {
        const percentageOfCorrectAnswers = correctAnswers * 100 / answersTotal;
        if (percentageOfCorrectAnswers >= 85) {
            return translations.goodJob;
        }
        if (percentageOfCorrectAnswers >= 75) {
            return translations.goodButKeepLearning;
        }

        if (percentageOfCorrectAnswers < 75) {
            return translations.contactYourDoctor;
        }
        return "";
    },[correctAnswers, answersTotal]);

    const getResultPercantage = useMemo((): string => {
        return `${translations.correctAnswers} ${correctAnswers} ${translations.from} ${answersTotal}`;
    },[correctAnswers, answersTotal]);

    return (
        <div className="thankYouScreen">
            <div className="thankYou">{translations.thankYou}</div>
            <div className="resultText">{getResultPercantage}</div>
            <div className="thankYou">{getResultText}</div>
            <div className="navigationButtonContainer">
                <button
                    onClick={handleShowResultsClick}
                    className="showResultsButton"
                >
                    {translations.showResults}
                </button>
            </div>

        </div>
  );
});
